<template>
<ValidationObserver ref="observer">
  <form ref="edit_spare_part_master_form" @submit.prevent="handleSubmit(updateSparePartMaster)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Part/Material Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout md-glutter">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
           <span style="color:brown">Spare Part Code</span><span style="color:red">*</span>
          </label> -->
            <div class="md-layout-item md-size-100 md-small-size-100">
              <validation-provider rules="code" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Part/Material Code</label>
                <md-input v-model="spare_part_master_code" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_code" />
                <span style="float:right;" class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          <!-- </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Part/Material Name</span><span style="color:red">*</span>
          </label> -->
            <div class="md-layout-item md-size-100 md-small-size-100">
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Part/Material Name</label>
                <md-input v-model="spare_part_master_name" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          <!-- </div>
        </div>

        

        <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Unit</span><span style="color:red">*</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="unit" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Unit</label>
                <md-input v-model="spare_part_master_unit" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_unit" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Unit Price</span><span style="color:red">*</span>
            </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="unitprice" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Unit Price</label>
                <md-input v-model="spare_part_master_unit_price" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.spare_part_master_unit_price" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          <!-- </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Type</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Type</label>
                <md-select v-model="spare_part_master_type" >
                  <md-option value="1">Spare Part</md-option>
                  <md-option value="2">Material</md-option>
                  <md-option value="3">Not Spare Part & Material</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.spare_part_master_type" />
              </md-field>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Category</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Category</label>
                <md-select v-model="spare_part_master_category" >
                  <md-option value="1">Fast Moving</md-option>
                  <md-option value="2">Slow Moving</md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.spare_part_master_category" />
              </md-field>
            </div>
          <!-- </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size 100"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Spare Part Alert Price</span>
          </label> -->
            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-field class="md-invalid">
                <label for="">Part/Material Alert Price</label>
                <md-input v-model="spare_part_master_alert_price" type="text" v-on:keypress="NumbersOnly"/>
                <validation-error :errors="apiValidationErrors.spare_part_master_alert_price" />
              </md-field>
            </div>
          <!-- </div>
          <div class="md-layout-item md-small-size 100"> -->
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Spare Part Trace Hold</span>
            </label> -->
          </div>
      </md-card-content>
      <md-card-header>
        
      <span>Threshold</span>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-glutter">
            <div  
            v-for="(item, index) in spare_part_master_threshold_list"
            :key="index"
            class="md-layout-item md-size-50 md-small-size-100">
                <md-field class="md-invalid">
                  <label for="">{{item.warehouse_name}} Threshold</label>
                  <md-input v-model="item.threshold" type="text" v-on:keypress="NumbersOnly"/>
                  <validation-error :errors="apiValidationErrors.spare_part_master_threshold" />
                </md-field>
              </div>


          </div>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import { extend, ValidationObserver  } from 'vee-validate';

Vue.use(VueSweetalert2);

// pesan error untuk field riquired
extend('name', {
  ...required,
  message: 'Part/Material Name field is required'
});
extend('code', {
  ...required,
  message: 'Part/Material Code field is required'
});
extend('unit', {
  ...required,
  message: 'Part/Material Unit field is required'
});
extend('unitprice', {
  ...required,
  message: 'Part/Material Unit Price field is required'
  });
  export default {
    name: "edit-service-categories-test",

    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({ 
      spare_part_master_code: null,
      spare_part_master_name: null,
      // spare_part_master_quantity_procurement: null,
      spare_part_master_unit: null,
      spare_part_master_unit_price: null,
      // spare_part_master_quantity_nota_bahan: null,
      spare_part_master_type: null,
      spare_part_master_category: null,
      spare_part_master_alert_price: null,
      spare_part_master_threshold_list: [],
    }),

    created() {
      this.getSparePartMasterData();
    },


    methods: {

      // direct ke list view table
      backtoList(id) {
      this.$router.replace({ name: 'List Spare Part Master' })
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      
      // ambil data sparepart
      async getSparePartMasterData(){
        // check apakah id di route ada
        if(this.$route.params.id){
          
        console.log(this.$route.params.id)
        // jika ada pangill data berdasarkan id
        await this.$store.dispatch("workshop_spare_part_master/get", this.$route.params.id)
        this.spare_part_master = await this.$store.getters["workshop_spare_part_master/spare_part_master"]
        this.spare_part_master_code = this.spare_part_master.spare_part_master_code;
        this.spare_part_master_name = this.spare_part_master.spare_part_master_name;
        // this.spare_part_master_quantity_procurement = this.spare_part_master.spare_part_master_quantity_procurement;
        this.spare_part_master_unit = this.spare_part_master.spare_part_master_unit;
        this.spare_part_master_unit_price = this.spare_part_master.spare_part_master_unit_price;
        // this.spare_part_master_quantity_nota_bahan = this.spare_part_master.spare_part_master_quantity_nota_bahan;
        this.spare_part_master_type = this.spare_part_master.spare_part_master_type;
        this.spare_part_master_category = this.spare_part_master.spare_part_master_category;
        this.spare_part_master_alert_price = this.spare_part_master.spare_part_master_alert_price;


        var query = {"filter":{spare_part_threshold_master_id:this.spare_part_master.id}}
        await this.$store.dispatch("workshop_spare_part_threshold/list",query)
        var list_threshold = await this.$store.getters["workshop_spare_part_threshold/list"];
        await this.$store.dispatch("workshop_warehouse/list")
        var list_warehouse = await this.$store.getters["workshop_warehouse/list"];
        var arr_threshold = []
        list_warehouse.forEach(function(warehouse) {
          const ids = []
          ids.push(parseInt(warehouse.id))
          var dataThreshold = list_threshold.filter( i => ids.includes( i.spare_part_threshold_warehouse.id ));
          console.log(dataThreshold[0])
          arr_threshold.push({
              id:dataThreshold[0].id,
              warehouse_name: warehouse.warehouse_name,
              warehouse_id: warehouse.id,
              threshold: dataThreshold[0].spare_part_threshold,
          });
        });
        this.spare_part_master_threshold_list = arr_threshold;

        // this.spare_part_master_threshold_list = this.spare_part_master_threshold_list;
        console.log(this.spare_part_master_threshold_list);
        }
        else{
          // jika tidak ada kembali ke list spare part master
          await this.$router.replace({name: 'List Spare Part Master'});
        }
      },

      // validasi edit data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return
        }
        Swal.fire({
          title: 'Are you sure?',
          text: 'The data will be edited!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Edit it!',
          cancelButtonText: 'No, cancel!',
          buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateSparePartMaster(id)
          }
        });
      },

      // fungsi edit data spare part master
      async updateSparePartMaster() {

        if(this.$route.params.id == null || !this.$route.params.id) {
          await this.$store.dispatch("alerts/error", "You are not allowed not change data of default users.")
          return
        }

        
        const data = {
          type: "workshop_spare_part_masters", 
          id: this.spare_part_master.id,

          spare_part_master_code: this.spare_part_master_code,
          spare_part_master_name: this.spare_part_master_name,
          // spare_part_master_quantity_procurement: this.spare_part_master_quantity_procurement,
          spare_part_master_unit: this.spare_part_master_unit,
          spare_part_master_unit_price: this.spare_part_master_unit_price,
          // spare_part_master_quantity_nota_bahan	: this.spare_part_master_quantity_nota_bahan,
          spare_part_master_type: this.spare_part_master_type,
          spare_part_master_category: this.spare_part_master_category,
          spare_part_master_alert_price: this.spare_part_master_alert_price,
          spare_part_master_threshold_list: this.spare_part_master_threshold_list
        }


        try {
          // kirim data ke api
          await this.$store.dispatch("workshop_spare_part_master/update", data)
          // panggil alert success
          await this.$store.dispatch("alerts/success", "Spare Part Master data changed successfully.")
          // kembali ke list spare part master
          await this.$router.replace({name: 'List Spare Part Master'});
          //this.$refs['password_form'].reset()
        } catch (e) {
          // panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>